import axios from 'axios';
import config from '../config';
import { getBaseUrlFromConfig } from '../utils/url_helpers';

const baseUrl = getBaseUrlFromConfig(config.biztechApi);

export const makePostRequest = (endpoint, body, headers) => {
  return axios
    .post(baseUrl + endpoint, body, headers)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const makeGetRequest = (endpoint, headers) => {
  return axios
    .get(baseUrl + endpoint, headers)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
